import React from 'react';
import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import {
  ELEMENT_TYPE,
  type DocumentElement as DocumentElementType,
} from '@eaco/forms-core';
import EntityPicker from './EntityPicker';
import { ENTITY_KINDS, userSnapshot } from './entityKinds';
import { DOCUMENT_ELEMENT_USERS_QUERY } from './queries';

const UserPicker: React.FC<{ element: DocumentElementType }> = ({
  element,
}) => (
  <EntityPicker
    element={element}
    query={DOCUMENT_ELEMENT_USERS_QUERY}
    collectionField="documentElementUsers"
    icon={faUser}
    iconColour="#e0327f"
    variant="avatar"
    defaults={{
      label: 'User',
      placeholder: 'Search for a user...',
    }}
    rowSubtitle={(row) => (row.email as string | null | undefined) || null}
    rowBadges={(row) => {
      const out: string[] = [];
      if (row.jobTitle) out.push(String(row.jobTitle));
      if (row.preferredName) out.push(`aka ${row.preferredName}`);
      return out;
    }}
    rowToSnapshot={userSnapshot}
    contextSpec={ENTITY_KINDS[ELEMENT_TYPE.user].contextSpec}
  />
);

export default UserPicker;
